module.exports = "<label class=\"kl-check {class}\" is-chk={checked} is-dis={disabled}\n       r-class={ {'is-part': checked === null, 'kl-check--block': block} } r-hide={!visible} title={name} on-click={this.check(undefined, $event)}>\n    <div class=\"kl-check__box\"><kl-icon type=\"tick\" /></div>{#if this.$body}{#inc this.$body}{#else}{name}{/if}\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLCheck/index.html
// module id = 396
// module chunks = 0